import { apiPost, API_BASE_URL, apiGet, apiPut, apiDelete } from './api';

// Helper function for GET requests


// Get all social media accounts
export const getAllAccounts = async (token = null) => {
  return await apiGet('/accounts', token);
};

// Get accounts by platform
export const getAccountsByPlatform = async (platform, token = null) => {
  return await apiGet(`/accounts/${platform}`, token);
};

// Add a new social media account
export const addAccount = async (accountData, token = null) => {
  return await apiPost('/accounts', accountData, token);
};

// Update a social media account
export const updateAccount = async (id, accountData, token = null) => {
  return await apiPut(`/accounts/${id}`, accountData, token);
};

// Delete a social media account (soft delete)
export const deleteAccount = async (id) => {
  return apiDelete(`/accounts/${id}?hard=true`);
};